import { initMap } from "./engrain-map";
import { addToastMessage } from './toast';
import { isMobile } from "../modules/utilities";
import { initDNI } from "../api/dni";

// let isMobile = window.innerWidth < 768;

// window.addEventListener('resize', () => {
//   isMobile = window.innerWidth < 768;
// })

export const handleOtherActions = (e) => {
  const dropdown = e.currentTarget.querySelector('.other-actions-dropdown');
  const dniId = e.currentTarget.getAttribute('data-dniId');
  e.preventDefault();
  if(dropdown) {
    if(!dropdown.hasAttribute('data-id')) dropdown.setAttribute('data-id', e.currentTarget.getAttribute('data-id'));
    if(!dropdown.dataset.listener) {
      dropdown.dataset.listener = 'true';
      dropdown.addEventListener('click', (e) => e.stopPropagation());
    }

    if(e.currentTarget.classList.contains('open')) {
      e.currentTarget.classList.remove('open');
      if(isMobile){
        e.currentTarget.append('.other-actions-dropdown.active');
      }
      document.querySelector('.other-actions-dropdown.active').classList.remove('active');
    } else {
      closeQuickAction();

      dropdown.classList.add('active');

      if(isMobile){
        if(!document.querySelectorAll('.other-overlay').length > 0){
          const overlay = document.createElement('DIV');
          overlay.classList.add('other-overlay');
          document.querySelector('body').append(overlay);
        }

        document.querySelector('.other-overlay').classList.add('active');
        document.querySelector('body').append(dropdown);
      } else {
        setTimeout(() => {
          document.addEventListener('click', closeQuickAction);
        }, 0);
      }

      initDNI(dniId);
      e.currentTarget.classList.add('open');
    }
  }
}

export const closeQuickAction = () => {
  const openOther = document.querySelector('.other.open');
  if(openOther){
    openOther.classList.remove('open');

    const activeDropdown = document.querySelector('.other-actions-dropdown.active');
    activeDropdown.classList.remove('active');

    if(isMobile){
      openOther.append(activeDropdown);
      document.querySelector('.other-overlay').classList.remove('active');
    }
  }
  document.removeEventListener('click', closeQuickAction);
}

export const handleAddToClipboard = (e) => {
  e.preventDefault();
  navigator.clipboard.writeText(e.currentTarget.getAttribute('data-address'));
  addToastMessage({
    body: 'Community address copied',
  });
}

export const showLeasingInfo = (e) => {
  e.preventDefault();
  const leasingModal = document.querySelector(".leasing-modal-wrapper");
  leasingModal.classList.toggle('open');
}

export const handleViewMap = (e) => {
  e.preventDefault();
  initMap(e.currentTarget.getAttribute('data-map-link'));
}



// WEBPACK FOOTER //
// ./src/js/components/other-actions.js